import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const downloadUniversalQr = (tokens: any, reqBody: any) => {
  const request: JFSRequest<{}> = {
    apiPath: `${sitConfig(tokens).baseUrl}${APIEndPoints.GetQRCode}`,
    method: 'POST',
    responseType: 'arraybuffer',
    config: sitConfig(tokens),
    headers: sitConfig(tokens).headers,
    body: reqBody,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { downloadUniversalQr }
